<template>
    <div class="container">
        <div class="card">
            <div class="card-body">
                <div class="text-center">
                    <h1>
                        我要提意见，我要提bug (╯‵□′)╯炸弹！•••*～●
                    </h1>
                </div>
                <div class="alert alert-info" role="alert">
                    ❕意见栏:<br>
                    @Everyone:欢迎大家留下自己宝贵的建议，你们的建议是我最大的动力。
                </div>
                <div class="record-content-input">
                    <textarea placeholder="请输入意见内容......" v-model="content" style="overflow-y:auto"
                        class=" form-control text" aria-label="With textarea">
                    </textarea>

                    <div class="float-end" style="margin-top: 10px;">
                        <button v-if="content" @click="addcomment" type="button" class="btn btn-primary">
                            提交
                        </button>

                        <button v-if="!content" type="button" class="btn  btn-outline-primary" data-bs-toggle="modal"
                            data-bs-target="#toastModal">
                            提交
                        </button>
                        <div class="modal fade" id="toastModal" tabindex="-1" aria-labelledby="toastModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h1 class="modal-title fs-5" id="exampleModalLabel">📣</h1>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        ⚠你不可以发送空的内容哦！！！
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                                            确定
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <BackToTop />

                <div class="record-content-list">
                    <div class="card" v-for="(comment, index) in paginatedComments"
                        :key="comment.id || pageStart + index" style="width: 100%; margin-top: 10px;">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-1 text-center">
                                    <img :src="comment.avatar" class="avatar" width="50" height="50" alt="" />
                                    <br>
                                    {{ comment.username }}
                                </div>
                                <div class="col-10 comment">{{ comment.commentContent }}</div>
                                <div class="col-1 text-center">
                                    <button v-if="isLove[pageStart + index]" @click="clicklove(pageStart + index)"
                                        type="button" class="love-toggle is-loved" aria-label="取消点赞">♥</button>
                                    <button v-else @click="clicklove(pageStart + index)" type="button"
                                        class="love-toggle" aria-label="点赞">♡</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <nav v-if="totalPages > 1" aria-label="comment pagination" class="mt-3 d-flex justify-content-center">
                    <ul class="pagination pagination-sm mb-0 themed-pagination">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <button class="page-link" @click="changePage(currentPage - 1)"
                                :disabled="currentPage === 1">上一页</button>
                        </li>
                        <li class="page-item" v-for="page in totalPages" :key="page"
                            :class="{ active: page === currentPage }">
                            <button class="page-link" @click="changePage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <button class="page-link" @click="changePage(currentPage + 1)"
                                :disabled="currentPage === totalPages">下一页</button>
                        </li>
                    </ul>
                </nav>

                <div v-if="Popup" class="toast-notice text-center">
                    {{ success ? "点赞成功！！！" : "您已取消点赞！！！" }}
                </div>

            </div>
        </div>
    </div>

</template>
<script>
import { useStore } from "vuex";
import $ from "jquery";
import BackToTop from "@/components/BackToTop.vue";
import { apiUrl } from "@/config/backend";

export default {
    name: "RecordContent",
    components: {
        BackToTop,
    },

    data() {
        return {
            recordId: "",
            store: useStore(),
            comments: [],
            content: "",
            currentPage: 1,
            pageSize: 5,
            isLove: [],
            Popup: false,
            success: false,
        };
    },

    computed: {
        pageStart() {
            return (this.currentPage - 1) * this.pageSize;
        },

        paginatedComments() {
            return this.comments.slice(this.pageStart, this.pageStart + this.pageSize);
        },

        totalPages() {
            const pages = Math.ceil(this.comments.length / this.pageSize);
            return pages > 0 ? pages : 1;
        },
    },

    methods: {
        getRecord() {
            let self = this;
            $.ajax({
                url: apiUrl("/comment/all/"),
                type: "get",
                headers: {
                    Authorization: "Bearer " + this.store.state.user.token,
                },
                success(resp) {
                    console.log(resp);
                    self.comments = resp;
                    self.isLove = new Array(resp.length).fill(false);
                    self.currentPage = 1;
                },
            });
        },

        addcomment() {
            let self = this;
            if (this.content === "") {
                return;
            } else {
                $.ajax({
                    url: apiUrl("/comment/add/"),
                    type: "get",
                    data: {
                        content: this.content,
                        userId: this.store.state.user.id,
                    },
                    headers: {
                        Authorization: "Bearer " + this.store.state.user.token,
                    },
                    success() {
                        self.content = '';
                        self.getRecord();
                    },
                });
            }
        },

        clicklove(index) {
            this.isLove[index] = !this.isLove[index];

            this.success = this.isLove[index];
            this.Popup = true;
            setTimeout(() => {
                this.Popup = false;
            }, 500);
        },

        changePage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },
    },

    mounted() {
        this.getRecord();
    },
};
</script>

<style scoped>
.container {
    margin-top: 20px;
    width: 80%;
}

.themed-pagination .page-link {
    background: var(--app-surface);
    color: var(--app-text);
    border-color: rgba(255, 255, 255, 0.2);
}

.themed-pagination .page-link:hover {
    background: rgba(255, 255, 255, 0.12);
}

.themed-pagination .active .page-link {
    background: #0d6efd;
    color: #fff;
    border-color: #0d6efd;
}

.avatar {
    margin-top: 10px;
    border-radius: 50%;
}

.record-content-list {
    margin-top: 60px;
}

.toast-notice {
    position: fixed;
    top: 88px;
    left: 50%;
    z-index: 3300;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    max-width: min(420px, calc(100% - 32px));
    padding: 11px 18px;
    color: var(--app-text);
    background: var(--app-surface-strong);
    border: 1px solid rgba(34, 197, 94, 0.38);
    border-radius: 12px;
    box-shadow: 0 18px 42px rgba(0, 0, 0, 0.22);
    transform: translateX(-50%);
    animation: toast-in 0.24s ease-out;
    backdrop-filter: blur(16px);
    font-weight: 700;
}

@keyframes toast-in {
    from {
        opacity: 0;
        transform: translate(-50%, -8px);
    }

    to {
        opacity: 1;
        transform: translate(-50%, 0);
    }
}

.love-toggle {
    width: 42px;
    height: 42px;
    display: inline-grid;
    place-items: center;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: rgba(100, 116, 139, 0.86);
    cursor: pointer;
    font-size: 31px;
    line-height: 1;
    transition: color 0.2s ease, background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
    user-select: none;
}

.love-toggle:hover {
    color: #f43f5e;
    background: rgba(244, 63, 94, 0.1);
    transform: translateY(-1px) scale(1.06);
}

.love-toggle.is-loved {
    color: #f43f5e;
    background: rgba(244, 63, 94, 0.12);
    box-shadow: 0 8px 22px rgba(244, 63, 94, 0.18);
    animation: love-pop 0.26s ease-out;
}

:global(body.dark) .love-toggle,
:global(.dark) .love-toggle {
    color: rgba(226, 232, 240, 0.72);
}

:global(body.dark) .love-toggle:hover,
:global(.dark) .love-toggle:hover,
:global(body.dark) .love-toggle.is-loved,
:global(.dark) .love-toggle.is-loved {
    color: #fb7185;
    background: rgba(251, 113, 133, 0.16);
}

@keyframes love-pop {
    0% {
        transform: scale(0.82);
    }

    70% {
        transform: scale(1.14);
    }

    100% {
        transform: scale(1);
    }
}
</style>
